import useFetch from '../hooks/useFetch'

export default () => {
  const fetch = useFetch()

  const parseErrorMessageFromJson = (response, jsonData = {}) => {
    const { error = 'error' } = jsonData;
    throw new Error(`/auth/verify error: ${response.status} ${error}`);
  }

  const getIsVerified = async () => {
    try {
      const response = await fetch('auth/verify', { method: 'GET' })
      if (response.ok) {
        const jsonData = await response.json()
        if (jsonData.error) {
          parseErrorMessageFromJson(response, jsonData)
        }
        const { status } = jsonData
        return status === true
      } else {
        const jsonData = await response.json()
        parseErrorMessageFromJson(response, jsonData)
      }
    } catch (e) {
      const msg = (e && e.message) || String(e)
      console.log(msg)
      return false
    }
  }

  return {
    getIsVerified
  }
}